export default __webpack_public_path__ + "static/media/multi.17922801.png";